module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-pl-ef6b815f132b70301a3581e67f00e4ab.svg";